import React from 'react';
import './InputHint.scss';

const InputHint = ({ children }) => <div className="input__hint">{children}</div>;

export default InputHint;